import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { IoMdAdd } from 'react-icons/io'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import InputNumber from '../../components/Inputs/InputNumber'
import InputText from '../../components/Inputs/InputText'
import PercentInput from '../../components/Inputs/PercentInput'
import { TextArea } from '../../components/Inputs/TextArea'
import { formatPipe } from '../../utils/utils'

const WithholdingForm: React.FC<IWithholdingForm> = ({
  onClose,
  onSubmit,
  title,
  fromPurchase = false
}) => {
  const form = useForm({defaultValues: {
    amountWithheld: 0,
    withholdingPercentage: 0,
    taxBase: 0,
    excempt: 0,
    subtrahend: 0,
    taxRate: 0,
    taxTotal: 0,
    
  }})

  let inputSubmitFileRef = useRef<HTMLInputElement | null>(null)
  const [document, setDocument] = useState<File | null>(null)

  const onSubmitImage = (e): void => {
    e.preventDefault()
    if (inputSubmitFileRef.current && inputSubmitFileRef.current.files) {
      console.log('VER', inputSubmitFileRef?.current?.files[0])
      setDocument(inputSubmitFileRef?.current?.files[0])
    }
  }

  const submitForm = (values) => {
    let body = {}
    if (title === 'ISLR') {
      body = {
        ...values,
        amountWithheld: formatPipe(values.amountWithheld, true),
        taxBase: formatPipe(values.taxBase, true),
        // excempt: values.excempt ? formatPipe(values.excempt, true) : null,
        taxTotal: formatPipe(values.taxTotal, true),
        withholdingPercentage: formatPipe(values.withholdingPercentage, true),
        subtrahend: formatPipe(values?.subtrahend, true),
        taxRate: 0,
        excempt: 0
      }
    } else {
      body = {
        ...values,
        amountWithheld: formatPipe(values.amountWithheld, true),
        taxBase: formatPipe(values.taxBase, true),
        // excempt: values.excempt ? formatPipe(values.excempt, true) : null,
        taxTotal: formatPipe(values.taxTotal, true),
        withholdingPercentage: formatPipe(values.withholdingPercentage, true),
        taxRate: formatPipe(values.taxRate, true),
        excempt: values?.taxRate ? formatPipe(values.taxRate, true) : 0
      }
    }
    onSubmit(body)
  }

  const percentInput = {
    'ISLR': 'Alícuota Impuesto',
    'Impuesto Municipal': 'Alícuota Impuesto',
    'OTHER': 'Alícuota Impuesto',
    'IVA': 'Alícuota IVA'
  }

  return (
    <Form
      form={form}
      classes={`gap-x-6 gap-y-3`}
      onSubmit={(values) => submitForm({ ...values, document })}
    >
      <input type="file" ref={inputSubmitFileRef} onChange={onSubmitImage} />
      <h2 className="col-span-12 text-primary-900 font-bold">
        {title === 'OTHER' ? 'Otras Retenciones' : `Retención ${title || ''}`}
      </h2>

      <FormItem
        name="amountWithheld"
        rules={{ required: 'Es necesario indicar el monto retenido' }}
        classes="xl:col-span-6 col-span-12"
      >
        {/* <InputNumber label="Monto retenido" addDecimals={true} /> */}
        <CurrencyInput label="Monto Retenido" addDecimals={true} mask={`Bs. num`} />
      </FormItem>

      <FormItem
        name="withholdingPercentage"
        rules={{ required: 'Es necesario indicar el porcentaje retendio' }}
        classes="xl:col-span-6 col-span-12"
      >
        <PercentInput label="Porcentaje Retenido" />
      </FormItem>

      { !fromPurchase && (
      <FormItem
        name="voucherNumber"
        rules={{ required: 'Es necesario indicar el nro de comprobante' }}
        classes="xl:col-span-6 col-span-12"
      >
        <InputText label="Nro Comprobante" />
      </FormItem>
      ) }

      <FormItem
        name="taxBase"
        rules={{ required: 'Es necesario indicar la base imponible' }}
        classes="xl:col-span-6 col-span-12"
      >
        {/* <InputNumber label="Base imponible" addDecimals={true} /> */}
        <CurrencyInput label="Base imponible" addDecimals={true} mask={`Bs. num`} />
      </FormItem>

      { title === 'IVA' && (
        <FormItem
          name="excempt"
          rules={{ required: 'Es necesario indicar el exento' }}
          classes="xl:col-span-6 col-span-12"
        >
          <CurrencyInput label="Exento" addDecimals={true} mask={`Bs. num`} />
        </FormItem>
      
      ) }

      { title === 'ISLR' && (
      <FormItem
        name={'subtrahend'}
        rules={{ required: 'Es necesario indicar la alícuota IVA' }}
        classes="xl:col-span-6 col-span-12"
      >
          <CurrencyInput label={'Sustraendo'} addDecimals={true} mask={`Bs. num`} />
      </FormItem>
      ) }


    {  title !== 'ISLR' && (
      <FormItem
      name={'taxRate'}
      rules={{ required: 'Es necesario indicar la alícuota IVA' }}
      classes="xl:col-span-6 col-span-12"
    >
        <PercentInput
          label={percentInput[title]}
        />
    </FormItem>
    ) }


      {/* <FormItem
        name={'taxRate'}
        rules={{ required: 'Es necesario indicar la alícuota IVA' }}
        classes="xl:col-span-6 col-span-12"
      >
        { title === 'ISLR' && (
          // <InputNumber label={percentInput[title]} addDecimals={true} />
          <CurrencyInput label={percentInput[title]} addDecimals={true} mask={`Bs. num`} />
        )}

        { title !== 'ISLR' && (
          <PercentInput
            label={percentInput[title]}
          />
        ) }
      </FormItem> */}

      <FormItem
        name="taxTotal"
        rules={{ required: 'Es necesario indicar el total de impuesto' }}
        classes="xl:col-span-6 col-span-12"
      >
        {/* <InputNumber label="Total impuesto" addDecimals={true} /> */}
        <CurrencyInput label="Total impuesto" addDecimals={true} mask={`Bs. num`} />
      </FormItem>

      {title === 'OTHER' && (
        <FormItem
          name="description"
          rules={{ required: 'Es necesario indicar la descripción' }}
          classes="xl:col-span-6 col-span-12"
        >
          <TextArea label="Descripción" addDecimals={true} placeholder="" />
        </FormItem>
      )}

      {/* <div className="flex col-span-4 my-2 flex-column">
        <div className="flex flex-row">
          <IoMdAdd className="text-primary" />
          <u
            className="text-xs text-primary cursor-pointer"
            onClick={() =>
              inputSubmitFileRef.current && inputSubmitFileRef.current.click()
            }
            style={{ color: '#006AEA', cursor: 'pointer' }}
          >
            Subir documento
          </u>
        </div>
        <label
          style={{
            display: 'block',
            fontSize: 15,
            fontWeight: 600,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'gray',
          }}
        >
          {document?.name}
        </label>
      </div> */}

      <div className="col-span-12 h-full flex flex-row mt-4">
        <div className="w-1/2 mr-5 pl-1">
          <Button
            onClick={() => {
              if (onClose) onClose()
            }}
            type="outline"
            classes="w-full"
          >
            Cancelar
          </Button>
        </div>
        <div className="w-1/2 pr-1">
          <Button type="primary" classes="w-full" htmlType="submit">
            Añadir
          </Button>
        </div>
      </div>
    </Form>
  )
}

interface IWithholdingForm {
  onClose: () => void
  onSubmit: (values: any) => void
  title: string
  fromPurchase?: boolean
}

export default WithholdingForm
